import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import useAuth from "../hooks/useAuth";
import "../assets/styles/bootstrap.css";

import { CDBInput, CDBCard, CDBCardBody, CDBBtn, CDBContainer } from "cdbreact";
import axios from "../api/axios";
import { useNavigate } from "react-router-dom";

const ROLES = {
  "Admin": 506,
  "User": 824,
  "Janitor": 821
}

const Login = () => {
  const { t } = useTranslation();
  const { setAuth } = useAuth();
  const navigate = useNavigate();

  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    setErrorMessage("")
  }, [userName, password]);


  const handleLogin = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post(
        "/auth/login",
        JSON.stringify({ userName, password }),
        {
          headers: {
            "Content-Type": "application/json",
            withCredentials: true
          }
        });
      const accessToken = response?.data?.accessToken;
      const refreshToken = response?.data?.refreshToken;
      const roles = [ROLES.User];
      setAuth({ userName, roles, accessToken, refreshToken });

      if (!accessToken || !refreshToken) {
        throw new Error("Access token or refresh token not provided");
      }

      setUserName("");
      setPassword("");
      navigate("/");
    } catch (error) {
      if (!error.response) {
        setErrorMessage("no server response");
      } else if (error.response.status === 400) {
        setErrorMessage("missing username or password");
      } else if (error.response?.status === 401) {
        setErrorMessage("unauthorized");
      } else {
        setErrorMessage("login failed");
        console.error("Failed to login:", error);
      }
    }
  };

  return (
    <CDBContainer className="cdb-container">
      <CDBCard style={{ width: "25rem", height: "20rem" }}>
        <CDBCardBody className="mx-4">
          <form onSubmit={handleLogin}>
            <label htmlFor="username" className="text-muted m-0">
              {t("username")}
            </label>
            <CDBInput
              id="username"
              className="mt-n3"
              type="text"
              onChange={(e) => setUserName(e.target.value)}
              value={userName}
            />
            <label htmlFor="password" className="text-muted m-0">
              {t("password")}
            </label>
            <CDBInput
              id="password"
              className="mt-n3"
              type="password"
              onChange={(e) => setPassword(e.target.value)}
              value={password}
            />
            <CDBBtn
              type="submit"
              color="dark"
              style={{ width: "40%" }}
              className="btn-block mt-5 mx-auto"
            >
              {t("login")}
            </CDBBtn>
          </form>
          <p
            className={errorMessage ? "errmsg" : "offscreen"}
            aria-live="assertive"
          >
            {errorMessage}
          </p>
        </CDBCardBody>
      </CDBCard>
    </CDBContainer>
  );
};

export default Login;
